export default __webpack_public_path__ + "static/amex-logo-1a1f06ec3477af608a055efd11f299d2.jpg";